import { TimeoutError } from "../models/errors/timeout-error";
export function createTimeout(tm, delay) {
    return new Promise((resolve, reject) => {
        let expired = false;
        const timeout = setTimeout(() => {
            expired = true;
            reject(new TimeoutError());
        }, delay);
        tm(() => {
            if (expired === false) {
                clearTimeout(timeout);
                resolve();
            }
        });
    });
}
